import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

export const api = {
  listTranches: () => client.get("/tranches").then((r) => r.data),
  createTranche: (body) => client.post("/tranches", body).then((r) => r.data),
  deleteTranche: (id) => client.delete(`/tranches/${id}`).then((r) => r.data),
  summary: () => client.get("/portfolio/summary").then((r) => r.data),
  ledger: () => client.get("/ledger").then((r) => r.data),
  listPayouts: () => client.get("/payouts").then((r) => r.data),
  createPayout: (body) => client.post("/payouts", body).then((r) => r.data),
  updatePayout: (id, status) => client.patch(`/payouts/${id}`, { status }).then((r) => r.data),
  deletePayout: (id) => client.delete(`/payouts/${id}`).then((r) => r.data),
  listDeductions: () => client.get("/deductions").then((r) => r.data),
  createDeduction: (body) => client.post("/deductions", body).then((r) => r.data),
  deleteDeduction: (id) => client.delete(`/deductions/${id}`).then((r) => r.data),
  seed: () => client.post("/seed").then((r) => r.data),
};
